// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1dE6t","productName":"Table_productName__1AOpC"};